import { createContext, useEffect, useState } from 'react'
import { s3 } from '~/utils/s3'
import { useUserLootboxes } from '../api/useUserLootboxes'

export const LootboxContext = createContext<LootboxContextType>(undefined)
const VIDEO_LEGACY = s3('/video/lootbox_open.mp4')
const VIDEO_SLASHER = s3('/video/lootbox-slasher_open.mp4')


export const LootboxProvider = ({ children }) => {
    const { data, isFetched } = useUserLootboxes()
    const [lootboxes, setLootboxes] = useState<LootboxType[]>([])
    const [currentOpening, setCurrentOpening] = useState<LootboxType>(undefined)
    const [videoSrc, setVideoSrc] = useState({
        legacy: undefined,
        slasher: undefined,
    })
    const [videoPlaying, setVideoPlaying] = useState(false)

    useEffect(() => {
        const fetchVideo = async (src, key) => {
            const reposne = await fetch(src)
            const blob = await reposne.blob()
            setVideoSrc(prev => ({ ...prev, [key]: URL.createObjectURL(blob) }))
        }
        fetchVideo(VIDEO_LEGACY, 'legacy')
        fetchVideo(VIDEO_SLASHER, 'slasher')
    }, [])

    useEffect(() => {
        if (data) setLootboxes(data.map((l) => ({ ...l, state: 'LOCKED' })))
    }, [data])

    return (
        <LootboxContext.Provider
            value={{
                lootboxes,
                isFetched,
                setLootboxes,
                currentOpening,
                setCurrentOpening,
                videoSrc,
                videoPlaying,
                setVideoPlaying,
            }}
        >
            {children}
        </LootboxContext.Provider>
    )
}
